import scrollIntoView from 'scroll-into-view';

const ERROR_CLASSES = [
  '.hasError',
];

const query = ERROR_CLASSES.join(',');

export const scrollToError = () => {
  // Wrap in a setTimeout so React has a chance to add the hasError classes to the invalid inputs
  setTimeout(() => {
    const errorElements = document.body.querySelectorAll<HTMLElement>(query);

    if (errorElements.length) {
      const firstErrorElement = errorElements.item(0);

      scrollIntoView(firstErrorElement, {
        time: 250,
      });
    }
  }, 20);
};
